import reconcilePersistedState from '../../helpers/reconcilePersistedState';

const defaultState = {
  displayedTicketIds: [],
};
const initialState = defaultState;

export function continueShoppingModal(state = initialState, action) {
  switch (action.type) {
    case 'CONTINUE_SHOPPING_MODAL_SET_TICKET_IDS':
      return { ...state, displayedTicketIds: Array.isArray(action.val) ? [...action.val] : state.displayedTicketIds };
    case 'RECONCILE_PERSISTED_STATE':
      return reconcilePersistedState(state, defaultState);
    default:
      return state;
  }
}
